var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "block-container" },
      [
        _c(
          "el-tabs",
          {
            on: { "tab-click": _vm.handleClick },
            model: {
              value: _vm.activeName2,
              callback: function($$v) {
                _vm.activeName2 = $$v
              },
              expression: "activeName2"
            }
          },
          [
            _vm.isShow &&
            (!_vm.srcFixed ||
              (_vm.srcFixed && _vm.srcFlag == _vm.dealInqryFlag.value))
              ? _c(
                  "el-tab-pane",
                  { attrs: { label: "询盘", name: "first" } },
                  [
                    _c("swb-deal-inqry-voucher-for-select", {
                      ref: "swb_deal_inqry_for_select",
                      attrs: {
                        rowId: _vm.dealInqryId,
                        type: _vm.type,
                        showSelect: _vm.showSelect,
                        toDealInqryVoucher: _vm.toDealInqryVoucher
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isShow &&
            (!_vm.srcFixed ||
              (_vm.srcFixed && _vm.srcFlag == _vm.priceInqryFlag.value))
              ? _c(
                  "el-tab-pane",
                  { attrs: { label: "询价", name: "second" } },
                  [
                    _c("swb-price-inpry-for-select", {
                      ref: "swb_price_inqry_for_select",
                      attrs: {
                        rowId: _vm.priceReplyId,
                        type: _vm.type,
                        showSelect: _vm.showSelect,
                        filter: _vm.priceInpryFilter,
                        toPriceInqryVoucher: _vm.toPriceInqryVoucher
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isShow &&
            (!_vm.srcFixed ||
              (_vm.srcFixed && _vm.srcFlag == _vm.bidDocFlag.value))
              ? _c(
                  "el-tab-pane",
                  { attrs: { label: "招标", name: "third" } },
                  [
                    _c("swb-call-bid-doc-for-select", {
                      ref: "swb_callBidDoc_select",
                      attrs: {
                        rowId: _vm.callbidId,
                        type: _vm.type,
                        showSelect: _vm.showSelect,
                        filter: _vm.callBidFilter,
                        toCallBidDoc: _vm.toCallBidDoc,
                        isAll: true
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b14ff36", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b14ff36","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/contract/ShowSourceTrace.vue
// module id = 3262
// module chunks = 0